export default __webpack_public_path__ + "static/for-account-executives-9a79a2548c799462ad27a4d77da68334.png";